import React, { HTMLAttributes, ReactNode } from "react";

import classnames from "classnames";

import { useWombatTheme } from "../../theme";

type FormEntryProps = {
  /**
   * Title of the form entry
   */
  title: ReactNode;
  /**
   * Description of the form entry
   */
  description?: ReactNode;
  /**
   * Add a visual indicator that the input is required
   */
  required?: boolean;
} & Omit<HTMLAttributes<HTMLDivElement>, "title">;

/**
 * FormEntry component is meant to receive any input children
 * Prefer to use CheckboxGroup and RadioGroup from Checkboxes & Radios inputs
 * as they enforce proper HTML semantic
 */
const FormEntry: React.FC<FormEntryProps> = ({
  title,
  description,
  required = false,
  children,
  ...props
}) => {
  const { theme } = useWombatTheme();

  const titleStyle = classnames(theme.form.entry.title);
  const descriptionStyle = classnames(theme.form.entry.description);
  const containerStyle = classnames(theme.form.entry.container);

  return (
    <div {...props}>
      <h5 className={titleStyle}>
        {title}
        {required && <span className="ml-2 text-danger-600">*</span>}
      </h5>
      {description && <div className={descriptionStyle}>{description}</div>}
      <div className={containerStyle}>{children}</div>
    </div>
  );
};

export default React.memo(FormEntry);
